/**
 * @generated SignedSource<<8b517fc070822eb7b582fd9bfd93a6de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CrawlRunScope = "ALL_SITES" | "SINGLE_SITE" | "%future added value";
export type CrawlRunStatus = "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "QUEUED" | "RUNNING" | "%future added value";
export type CrawlTrigger = "MANUAL" | "NIGHTLY" | "%future added value";
export type requestListingCrawlMutation$variables = {
  scope: CrawlRunScope;
  siteId?: any | null | undefined;
};
export type requestListingCrawlMutation$data = {
  readonly requestListingCrawl: {
    readonly completedUtc: any | null | undefined;
    readonly id: any;
    readonly listingsAdded: number;
    readonly listingsDelisted: number;
    readonly listingsMissed: number;
    readonly listingsUnchanged: number;
    readonly listingsUpdated: number;
    readonly rejectsQueued: number;
    readonly requestedByOperator: string;
    readonly requestedUtc: any;
    readonly scope: CrawlRunScope;
    readonly siteId: any | null | undefined;
    readonly sitesCrawled: number;
    readonly startedUtc: any | null | undefined;
    readonly status: CrawlRunStatus;
    readonly trigger: CrawlTrigger;
  };
};
export type requestListingCrawlMutation = {
  response: requestListingCrawlMutation$data;
  variables: requestListingCrawlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scope"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
      },
      {
        "kind": "Variable",
        "name": "siteId",
        "variableName": "siteId"
      }
    ],
    "concreteType": "CrawlRunSummary",
    "kind": "LinkedField",
    "name": "requestListingCrawl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trigger",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedByOperator",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scope",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sitesCrawled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsAdded",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsUpdated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsUnchanged",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsMissed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "listingsDelisted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectsQueued",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestListingCrawlMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestListingCrawlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "12fa29281a742fde27352ba8c1d0f339",
    "id": null,
    "metadata": {},
    "name": "requestListingCrawlMutation",
    "operationKind": "mutation",
    "text": "mutation requestListingCrawlMutation(\n  $scope: CrawlRunScope!\n  $siteId: UUID\n) {\n  requestListingCrawl(scope: $scope, siteId: $siteId) {\n    id\n    trigger\n    requestedByOperator\n    scope\n    siteId\n    status\n    requestedUtc\n    startedUtc\n    completedUtc\n    sitesCrawled\n    listingsAdded\n    listingsUpdated\n    listingsUnchanged\n    listingsMissed\n    listingsDelisted\n    rejectsQueued\n  }\n}\n"
  }
};
})();

(node as any).hash = "287218aeaccfd505f44008c84d271d56";

export default node;
